var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBlueWallet = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.9934 12.676H26.9929L26.9536 25.0158H3.00659V8.30242H3.03802C3.013 8.15457 3 8.00298 3 7.84858C3 6.27934 4.34327 5 5.99091 5H24.029V9.24767H27V12.6697L26.9934 12.676ZM25.4781 10.6972V12.5249H25.4781L25.445 23.5726H4.52192V10.3286C4.95621 10.5631 5.45762 10.6972 5.99091 10.6972H25.4781ZM5.99091 6.4495C5.17702 6.4495 4.51533 7.07972 4.51533 7.85488C4.51533 8.63005 5.17702 9.26027 5.99091 9.26027H22.507V6.4495H5.99091ZM20.9057 16.4006H24.0157V17.8438H20.9057V16.4006Z",
    fill: "#006EF5"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBlueWallet);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/BlueWallet.546af167e009c34450c9dd87da3ad786.svg";